// src/components/Dashboard/HomeDashbord.jsx

import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../Auth/AuthContext";
import "../../css/HomeDashboard.css";

// Header Component
const Header = ({ name }) => (
  <div className="dashboard-header">
    <h1 className="dashboard-title">داشبورد دانشجو</h1>
    <p className="dashboard-subtitle">
      دانشجوی عزیز <span className="student-name">({name || "دانشجو"})</span>{" "}
      خوش آمدید
    </p>
  </div>
);

// Summary Card Component
const SummaryCard = ({ title, value, description }) => (
  <div className="summary-card">
    <h3 className="summary-title">{title}</h3>
    <p className="summary-value">{value}</p>
    <p className="summary-desc">{description}</p>
  </div>
);

// Student Summary Component
const StudentSummary = () => (
  <div className="summary-container">
    <SummaryCard
      title="دوره‌های فعال"
      value="1"
      description="از 1 دوره ثبت‌نام‌شده"
    />
  </div>
);

// Enrolled Courses Component
const EnrolledCourses = () => {
  const courses = [{ id: 1, name: "مستر پلاس وردپرس", progress: 50 }];

  return (
    <div className="dashboard-card">
      <h2 className="card-title">دوره‌های فعال</h2>
      <ul className="course-list">
        {courses.map((course) => (
          <li key={course.id} className="course-item">
            <div className="course-info">
              <span className="course-name">{course.name}</span>
              <span className="course-percent">{course.progress}%</span>
            </div>
            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${course.progress}%` }}
              ></div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

// Upcoming Events Component
const UpcomingEvents = () => {
  const events = [
    {
      id: 1,
      name: "برگزاری کمپین بلک فرایدی",
      date: "1404/09/04",
      time: "23:59",
    },
    // { id: 2, name: "امتحان میان‌ترم جاوااسکریپت", date: "1402/04/20", time: "10:00" },
    // { id: 3, name: "وبینار هوش مصنوعی", date: "1402/04/25", time: "18:00" },
  ];

  return (
    <div className="dashboard-card">
      <h2 className="card-title">رویدادهای پیش رو</h2>
      <ul className="event-list">
        {events.map((event) => (
          <li key={event.id} className="event-item">
            <div className="event-icon">📅</div>
            <div className="event-details">
              <span className="event-name">{event.name}</span>
              <span className="event-time">
                {event.date} - ساعت {event.time}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

// Student Actions Component — نسخه رنگی و جذاب
const StudentActions = () => {
  const actions = [
    {
      id: 1,
      label: "مشاهده همه دوره‌ها",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1-1-1v-17H4" />
          <polyline points="14,2 14,8 20,8" />
        </svg>
      ),
      link: "/dashboard/courses",
      color: "blue",
    },
    {
      id: 2,
      label: "سفارشات من",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
          <line x1="3" y1="6" x2="21" y2="6" />
          <path d="M16 10a4 4 0 0 1-8 0" />
        </svg>
      ),
      link: "/dashboard/orders",
      color: "purple",
    },
    {
      id: 3,
      label: "پروفایل من",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
          <circle cx="12" cy="7" r="4" />
        </svg>
      ),
      link: "/dashboard/profile",
      color: "light",
    },
  ];

  return (
    <div className="dashboard-card">
      <h2 className="card-title">دسترسی سریع</h2>
      <div className="actions-container">
        {actions.map((action) => (
          <Link key={action.id} to={action.link} className="action-link">
            <button
              className={`action-button action-button--${action.color}`}
              aria-label={action.label}
            >
              <span className="action-icon">{action.icon}</span>
              <span className="action-label">{action.label}</span>
            </button>
          </Link>
        ))}
      </div>
    </div>
  );
};

// Main Dashboard Component
const HomeDashbord = () => {
  const { user } = useAuth();
  const name = user?.username;

  return (
    <div className="dashboard-container">
      <Header name={name} />
      <div className="dashboard-content">
        <div className="main-content">
          <StudentSummary />
          <EnrolledCourses />
          <UpcomingEvents />
        </div>
        <div className="sidebar">
          <StudentActions />
        </div>
      </div>
    </div>
  );
};

export default HomeDashbord;
